import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { Settings } from '../app.settings';

@Injectable()
export class DataProvider {

  constructor(private http: HttpClient, private settings: Settings) {

  }

  public getData(dataUrl) {
    return this.http.get(this.settings.apiUrl + dataUrl).pipe(map((response: any) => response as any));
  }

  public postData(dataUrl, body) {
    return this.http.post(this.settings.apiUrl + dataUrl, body).pipe(map((response: any) => response as any));
  }
}
